import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const ResolveReportSlice = createSlice({
    name: 'resolveReport',
    initialState,
    reducers: {
        resolveReportRequest(state) {
            state.loading = true;
            state.error = undefined;
        },
        resolveReportSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        resolveReportError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        resolveReportReset(state) {
            state.loading = false;
            state.response = undefined;
            state.error = undefined;
        },
    },
});

export const {
    resolveReportRequest,
    resolveReportSuccess,
    resolveReportError,
    resolveReportReset,
} = ResolveReportSlice.actions;

export default ResolveReportSlice.reducer;

